import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Image, Table, Form, Input, Flex, Modal, Tag, Space, Descriptions, Tooltip, Badge, message, Spin, Divider } from 'antd';
import {
  LockOutlined, RetweetOutlined, EyeOutlined, ShoppingOutlined,
  CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined,
  TruckOutlined, FilePdfOutlined, ReloadOutlined, CreditCardOutlined,
  PrinterOutlined, ShoppingCartOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { Animated } from "react-animated-css";
import { API } from '../components/Initilization'
import { getOrderDetail, repurchaseOrder } from '../services/productApi';
import { useNotificationContext } from '../components/NotificationContext'
import { useNavigate } from 'react-router-dom';
import LogOutIcon from '../assets/images/Icons/logout.png';
import OrdersIcon from '../assets/images/Icons/orders.png';
import PasswordIcon from '../assets/images/Icons/password.png';
import PasswordImage from '../assets/images/password.png';

const UserDashboard = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [orderDetailLoading, setOrderDetailLoading] = useState(false);

  useEffect(() => {
    GetOrdersList();
  }, []);

  const notif = useNotificationContext();
  const [visibleTypeIndex, setVisibleTypeIndex] = useState(["changepass", "orders", "main", "logout"]);
  const [stepVisible, setStepVisible] = useState("main");
  const [visibleOrders, setVisibleOrders] = useState(false);
  const [visibleChangePass, setVisibleChangePass] = useState(false);
  const [animationOutType, setAnimationOutType] = useState("fadeOut");
  const [tableDataSource, setTableDataSource] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetailModal, setOrderDetailModal] = useState(false);
  const [payingOrder, setPayingOrder] = useState(false);

  const showMenu = () => {
    setVisibleChangePass(false);
    setVisibleOrders(false);
    setTimeout(() => {
      setAnimationOutType("fadeOut");
      setVisibleTypeIndex([]);
      setTimeout(() => {
        setVisibleTypeIndex(["changepass", "orders", "main", "logout"]);
        setStepVisible("main");
      }, 1000);
    }, 700);
  };

  const handlevisibleType = (index) => {
    setVisibleTypeIndex([index]);
    setTimeout(() => {
      setAnimationOutType("fadeOutLeft");
      setVisibleTypeIndex([]);
      if (index === "logout") {
        localStorage.setItem('access_token', "");
        localStorage.setItem('refresh_token', "");
        axios.defaults.headers.common['Authorization'] = "";
        navigate("/");
      }
      setTimeout(() => {
        setStepVisible(index);
        switch (index) {
          case "changepass":
            setVisibleChangePass(true);
            break;
          case "orders":
            setVisibleOrders(true);
            break;
        }
      }, 1000);
    }, 700);
  };

  const GetOrderStatus = (key) => {
    const statusMap = {
      "1": { text: "ثبت سفارش", color: "processing", icon: <ClockCircleOutlined /> },
      "2": { text: "آماده سازی", color: "warning", icon: <ReloadOutlined /> },
      "3": { text: "تحویل داده شده", color: "success", icon: <TruckOutlined /> },
      "4": { text: "لغو سفارش", color: "error", icon: <CloseCircleOutlined /> },
      "5": { text: "حذف شده", color: "default", icon: <CloseCircleOutlined /> }
    };
    return statusMap[key] || { text: "نامشخص", color: "default", icon: <ClockCircleOutlined /> };
  };

  const GetOrdersList = () => {
    API.get('/api/order/my-orders', { NeedsAuthorization: true })
      .then(function (response) {
        if (response.status === 200) {
          const tableData = [];
          (response.data || []).forEach((item, index) => {
            const status = GetOrderStatus(item.OrderStatus);
            const jalaliDate = item.created.split("T")[0];
            tableData.push({
              key: item.id,
              orderRow: index + 1,
              orderId: item.id,
              orderDate: jalaliDate,
              orderStatus: status.text,
              orderStatusColor: status.color,
              orderStatusIcon: status.icon,
              orderPaymentStatus: item.Paid ? "پرداخت شده" : "در انتظار پرداخت",
              orderPaymentStatusColor: item.Paid ? "green" : "orange",
              orderTotalPrice: item.OrderTotalPrice?.toLocaleString() || "0",
              paid: item.Paid,
              itemsCount: (item.orderable_orders?.length || 0) + (item.designed_orders?.length || 0)
            });
          });
          setTableDataSource(tableData);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleViewOrderDetails = async (orderId) => {
    setOrderDetailLoading(true);
    setSelectedOrder(null);
    try {
      const response = await getOrderDetail(orderId);
      if (response.status === 200 && (response.data.ResultCode === 200 || response.data.id)) {
        setSelectedOrder(response.data);
        setOrderDetailModal(true);
      } else {
        message.error('خطا در دریافت جزئیات سفارش');
      }
    } catch (error) {
      console.error('Error fetching order details:', error);
      message.error('خطا در دریافت جزئیات سفارش');
    } finally {
      setOrderDetailLoading(false);
    }
  };

  const handleRepay = async (order) => {
    setPayingOrder(true);
    try {
      const bodyFormData = new FormData();
      bodyFormData.append('Amount', order.orderTotalPrice.replaceAll(",", ""));
      bodyFormData.append('Description', `پرداخت سفارش شماره ${order.orderId}`);
      bodyFormData.append('Type', "1");
      bodyFormData.append('PurchaseId', order.orderId);

      const response = await API.post('/api/payment/request', bodyFormData, {
        NeedsAuthorization: true
      });

      if (response.status === 200 && response.data.status) {
        sessionStorage.setItem('currentOrderId', order.orderId);
        sessionStorage.setItem('paymentAuthority', response.data.authority);
        sessionStorage.setItem('isRepayment', 'true');

        window.location.href = response.data.url;
      } else {
        notif.open({
          type: 'error',
          style: { width: "450px" },
          className: "fYekan-bold",
          placement: 'topRight',
          message: 'خطا',
          description: response.data.message || 'خطا در اتصال به درگاه پرداخت',
        });
      }
    } catch (error) {
      console.error('Payment request error:', error);
      notif.open({
        type: 'error',
        style: { width: "450px" },
        className: "fYekan-bold",
        placement: 'topRight',
        message: 'خطا',
        description: 'خطا در اتصال به درگاه پرداخت',
      });
    } finally {
      setPayingOrder(false);
    }
  };

  const handleRepurchase = async (orderId) => {
    setLoading(true);
    try {
      const response = await repurchaseOrder(orderId);
      if (response.status === 200 && response.data.ResultCode === 200) {
        message.success('محصولات به سبد خرید اضافه شد');
        navigate('/cart');
      } else {
        message.error(response.data.ResultMessage || 'خطا در افزودن به سبد خرید');
      }
    } catch (error) {
      console.error('Error repurchasing:', error);
      message.error('خطا در افزودن به سبد خرید');
    } finally {
      setLoading(false);
    }
  };

  const handlePrintInvoice = (orderId) => {
    window.open(`/api/order/print-purchase-instance/${orderId}`, '_blank');
  };

  const ChangePassword = async () => {
    const values = await form.validateFields();
    if (values.NewPassword !== values.NewRePassword) {
      notif.open({
        type: 'error',
        style: { width: "450px" },
        className: "fYekan-bold",
        placement: 'topRight',
        message: 'خطا',
        description: 'رمز عبور جدید با تکرار آن مطابقت ندارد',
      });
      return;
    }

    setLoading(true);
    const bodyFormData = new FormData();
    bodyFormData.append("current_password", values.CurrentPassword);
    bodyFormData.append("new_password", values.NewPassword);

    API.post('/api/account/change-password', bodyFormData, { NeedsAuthorization: true })
      .then(function (response) {
        if (response.status === 200 && response.data.ResultCode === 200) {
          notif.open({
            type: 'success',
            style: { width: "450px" },
            className: "fYekan-bold",
            placement: 'topRight',
            message: 'موفق',
            description: 'رمز عبور با موفقیت تغییر کرد',
          });
          form.resetFields();
          showMenu();
        } else {
          notif.open({
            type: 'error',
            style: { width: "450px" },
            className: "fYekan-bold",
            placement: 'topRight',
            message: 'خطا',
            description: response.data.ResultMessage || 'تغییر رمز با خطا مواجه شد',
          });
        }
      })
      .catch((error) => {
        notif.open({
          type: 'error',
          style: { width: "450px" },
          className: "fYekan-bold",
          placement: 'topRight',
          message: 'خطا',
          description: 'خطا در ارتباط با سرور',
        });
      })
      .finally(() => setLoading(false));
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'orderRow',
      key: 'orderRow',
      width: 70,
    },
    {
      title: 'شماره سفارش',
      dataIndex: 'orderId',
      key: 'orderId',
      width: 100,
      render: (id) => <Tag color="purple">#{id}</Tag>
    },
    {
      title: 'تاریخ سفارش',
      dataIndex: 'orderDate',
      key: 'orderDate',
      width: 120,
    },
    {
      title: 'تعداد اقلام',
      dataIndex: 'itemsCount',
      key: 'itemsCount',
      width: 100,
      render: (count) => <Badge count={count} showZero />
    },
    {
      title: 'وضعیت سفارش',
      dataIndex: 'orderStatus',
      key: 'orderStatus',
      width: 130,
      render: (text, record) => (
        <Tag color={record.orderStatusColor} icon={record.orderStatusIcon}>
          {text}
        </Tag>
      )
    },
    {
      title: 'وضعیت پرداخت',
      dataIndex: 'orderPaymentStatus',
      key: 'orderPaymentStatus',
      width: 130,
      render: (text, record) => (
        <Badge color={record.orderPaymentStatusColor} text={text} />
      )
    },
    {
      title: 'مبلغ (تومان)',
      dataIndex: 'orderTotalPrice',
      key: 'orderTotalPrice',
      width: 150,
      render: (price) => (
        <span style={{ color: '#a23854', fontWeight: 'bold' }}>{price}</span>
      )
    },
    {
      title: 'عملیات',
      key: 'actions',
      width: 200,
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="مشاهده جزئیات">
            <Button icon={<EyeOutlined />} onClick={() => handleViewOrderDetails(record.orderId)} size="small" />
          </Tooltip>
          {!record.paid && record.orderPaymentStatus === "در انتظار پرداخت" && (
            <Tooltip title="پرداخت سفارش">
              <Button
                type="primary"
                icon={<CreditCardOutlined />}
                onClick={() => handleRepay(record)}
                size="small"
                loading={payingOrder}
                style={{ background: '#52c41a', borderColor: '#52c41a' }}
              />
            </Tooltip>
          )}

        </Space>
      )
    }
  ];

  const getPaymentStatusBadge = (paid) => {
    if (paid) {
      return <Tag color="green" icon={<CheckCircleOutlined />}>پرداخت شده</Tag>;
    }
    return <Tag color="orange" icon={<ClockCircleOutlined />}>در انتظار پرداخت</Tag>;
  };

  const calculateProductTotal = (order) => {
    if (!order) return 0;
    let total = 0;
    if (order.orderable_orders) {
      order.orderable_orders.forEach(item => {
        total += item.TotalPrice;
      });
    }
    if (order.designed_orders) {
      order.designed_orders.forEach(item => {
        total += item.TotalPrice;
      });
    }
    return total;
  };

  // Calculate VAT (10% on product total only)
  const calculateVAT = (order) => {
    const productTotal = calculateProductTotal(order);
    return Math.floor(productTotal * 0.1);
  };

  // Calculate final total (products + VAT + shipping)
  const calculateFinalTotal = (order) => {
    const productTotal = calculateProductTotal(order);
    const vat = calculateVAT(order);
    const shipping = order.ShippingCost || 0;
    return productTotal + vat + shipping;
  };

  return (
    <Row style={{ maxWidth: "1200px", flex: 1, margin: "0 auto" }} align={"center"}>
      {stepVisible === "main" && (
        <Row style={{ maxWidth: "1200px" }} gutter={[24, 24]} align={"center"}>

          <Col align="center" span={12}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("orders")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}
                hoverable
                style={{
                  minWidth: 130,
                }}
                onClick={() => handlevisibleType("orders")}
                cover={<img height={220} src={OrdersIcon} />}
              >
                <p className="fYekan-bold font-3">سفارشات من</p>
              </Card>
            </Animated>
          </Col>

          <Col align="center" span={12}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("changepass")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}
                hoverable
                style={{
                  minWidth: 130,
                }}
                onClick={() => handlevisibleType("changepass")}
                cover={<img height={220} src={PasswordIcon} />}
              >
                <p className="fYekan-bold font-3">تغییر رمز عبور</p>
              </Card>
            </Animated>
          </Col>

          <Col align="center" span={12}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("logout")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}
                hoverable
                style={{
                  minWidth: 130,
                }}
                onClick={() => handlevisibleType("logout")}
                cover={<img height={220} src={LogOutIcon} />}
              >
                <p className="fYekan-bold font-3">خروج از حساب کاربری</p>
              </Card>
            </Animated>
          </Col>

        </Row>
      )}

      {/* ChangePass */}
      {stepVisible === "changepass" && (
        <Col align="center" span={24}>
          <Animated
            animationOut="fadeOut"
            animationOutDuration={1000}
            animationIn="slideInRight"
            animationInDuration={1000}
            isVisible={visibleChangePass}
          >
            <Card
              bodyStyle={{ padding: "8px" }}
              className="fEstedad light-glass-effect-card shaped-border text-right"
              title="تغییر رمز عبور"
              style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}
            >
              <Row style={{ flex: 1, alignItems: 'center' }}>
                <Col order={1} align={"center"} span={24} lg={0}>
                  <img className="smooth-shadow-img" src={PasswordImage} width={270} alt="Login" />
                </Col>
                <Col order={1} span={24} lg={12}>
                  <Flex align="center" justify="center">
                    <Form
                      form={form}
                      name="layout-multiple-vertical"
                      layout="vertical"
                      className="fEstedad"
                      onFinish={ChangePassword}
                    >
                      <Form.Item
                        label="رمز عبور فعلی"
                        name="CurrentPassword"
                        rules={[{ required: true, message: 'لطفاً رمز عبور فعلی را وارد کنید' }]}
                      >
                        <Input.Password style={{ direction: "ltr" }} prefix={<LockOutlined />} />
                      </Form.Item>

                      <Form.Item
                        label="رمز عبور جدید"
                        name="NewPassword"
                        rules={[
                          { required: true, message: 'لطفاً رمز عبور جدید را وارد کنید' },
                          { min: 6, message: 'رمز عبور باید حداقل 6 کاراکتر باشد' }
                        ]}
                      >
                        <Input.Password style={{ direction: "ltr" }} prefix={<LockOutlined />} />
                      </Form.Item>

                      <Form.Item
                        label="تکرار رمز عبور جدید"
                        name="NewRePassword"
                        rules={[
                          { required: true, message: 'لطفاً رمز عبور جدید را تکرار کنید' },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue('NewPassword') === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('رمز عبور جدید با تکرار آن مطابقت ندارد'));
                            },
                          }),
                        ]}
                      >
                        <Input.Password style={{ direction: "ltr" }} prefix={<RetweetOutlined />} />
                      </Form.Item>

                      <Form.Item>
                        <Row gutter={[24, 24]} style={{ flex: 1, alignItems: 'center' }}>
                          <Col align={"center"} span={24} md={12}>
                            <Button onClick={showMenu} color="text" variant="outlined">بازگشت به منو</Button>
                          </Col>
                          <Col align={"center"} span={24} md={12}>
                            <Button htmlType="submit" type="primary" loading={loading}>تغییر رمز عبور</Button>
                          </Col>
                        </Row>
                      </Form.Item>
                    </Form>
                  </Flex>
                </Col>
                <Col order={2} align={"center"} span={0} lg={12}>
                  <Image className="smooth-shadow-img" src={PasswordImage} preview={false} />
                </Col>
              </Row>
            </Card>
          </Animated>
        </Col>
      )}

      {/* Orders */}
      {stepVisible === "orders" && (
        <Col align="center" span={24} md={24}>
          <Animated
            animationOut="fadeOut"
            animationOutDuration={1000}
            animationIn="slideInRight"
            animationInDuration={1000}
            isVisible={visibleOrders}
          >
            <Card
              className="light-glass-effect-card"
              bodyStyle={{ padding: "0" }}
              hoverable
              style={{ width: "100%", minWidth: "350px" }}
            >
              <Row style={{ flex: 1, alignItems: 'center' }}>
                <Col style={{ padding: "5px" }} span={24}>
                  <Table
                    columns={columns}
                    dataSource={tableDataSource}
                    pagination={{ pageSize: 10 }}
                    scroll={{ x: 'max-content' }}
                    locale={{ emptyText: "هیچ سفارشی یافت نشد" }}
                  />
                </Col>
              </Row>
            </Card>
            <Col className="mt-3" align={"right"} span={24} md={24}>
              <Button onClick={showMenu} color="text" type="secondary">بازگشت به منو</Button>
            </Col>
          </Animated>
        </Col>
      )}

      {/* Order Detail Modal */}
      <Modal
        title={`جزئیات سفارش #${selectedOrder?.id}`}
        open={orderDetailModal}
        onCancel={() => setOrderDetailModal(false)}
        footer={[
          <Button key="close" onClick={() => setOrderDetailModal(false)}>بستن</Button>,

        ]}
        width={900}
      >
        {orderDetailLoading ? (
          <div style={{ textAlign: 'center', padding: 50 }}>
            <Spin size="large" />
          </div>
        ) : selectedOrder && (
          <>
            <Descriptions bordered column={{ xs: 1, sm: 2 }} size="small">
              <Descriptions.Item label="شماره سفارش">#{selectedOrder.id}</Descriptions.Item>
              <Descriptions.Item label="تاریخ ثبت">
                {selectedOrder.created?.split("T")[0]}
              </Descriptions.Item>
              <Descriptions.Item label="وضعیت سفارش">
                <Tag color={GetOrderStatus(selectedOrder.OrderStatus).color}>
                  {GetOrderStatus(selectedOrder.OrderStatus).text}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="وضعیت پرداخت">
                {getPaymentStatusBadge(selectedOrder.Paid)}
              </Descriptions.Item>
              <Descriptions.Item label="استان">{selectedOrder.Province}</Descriptions.Item>
              <Descriptions.Item label="شهر">{selectedOrder.City}</Descriptions.Item>
              <Descriptions.Item label="آدرس" span={2}>{selectedOrder.DeliveryAddress}</Descriptions.Item>
              <Descriptions.Item label="کد پستی">{selectedOrder.PostalCode}</Descriptions.Item>
              <Descriptions.Item label="توضیحات" span={2}>{selectedOrder.Description || '-'}</Descriptions.Item>
            </Descriptions>

            <Divider orientation="center">محصولات سفارش</Divider>

            {/* Orderable Products */}
            {selectedOrder.orderable_orders?.length > 0 && (
              <>
                <h4>محصولات آماده</h4>
                <Table
                  dataSource={selectedOrder.orderable_orders}
                  rowKey="id"
                  pagination={false}
                  size="small"
                  columns={[
                    { title: 'نام محصول', dataIndex: 'ProductTitle', key: 'title' },
                    { title: 'قیمت واحد', dataIndex: 'ProductPrice', key: 'price', render: (p) => p?.toLocaleString() },
                    { title: 'تعداد', dataIndex: 'Quantity', key: 'qty' },
                    { title: 'جمع', dataIndex: 'TotalPrice', key: 'total', render: (p) => p?.toLocaleString() }
                  ]}
                />
              </>
            )}

            {/* Designed Products */}
            {selectedOrder.designed_orders?.length > 0 && (
              <>
                <h4 style={{ marginTop: 16 }}>محصولات طراحی شده</h4>
                <Table
                  dataSource={selectedOrder.designed_orders}
                  rowKey="id"
                  pagination={false}
                  size="small"
                  columns={[
                    { title: 'نام محصول', dataIndex: 'ProductName', key: 'name' },
                    { title: 'رنگ', dataIndex: 'ProductColor', key: 'color', render: (c) => c || '-' },
                    { title: 'سایز', dataIndex: 'ProductSize', key: 'size', render: (s) => s || '-' },
                    { title: 'کیفیت', dataIndex: 'ProductQuality', key: 'quality', render: (q) => q === '1' ? 'معمولی' : q === '2' ? 'خوب' : q === '3' ? 'فوق العاده' : q || '-' },
                    { title: 'تعداد', dataIndex: 'Amount', key: 'qty' },
                    { title: 'قیمت واحد', dataIndex: 'UnitPrice', key: 'price', render: (p) => p?.toLocaleString() },
                    { title: 'جمع', dataIndex: 'TotalPrice', key: 'total', render: (p) => p?.toLocaleString() }
                  ]}
                  expandable={{
                    expandedRowRender: (record) => (
                      <div>
                        <p><strong>تصویر طراحی جلو:</strong></p>
                        <img src={record.FirstDesignPic} alt="طراحی جلو" style={{ maxWidth: 150, borderRadius: 8 }} />
                        {record.SecondDesignPic && (
                          <>
                            <p style={{ marginTop: 8 }}><strong>تصویر طراحی پشت:</strong></p>
                            <img src={record.SecondDesignPic} alt="طراحی پشت" style={{ maxWidth: 150, borderRadius: 8 }} />
                          </>
                        )}
                        {record.AdditionalDesignImages?.length > 0 && (
                          <>
                            <p style={{ marginTop: 8 }}><strong>تصاویر اضافی:</strong></p>
                            <Space wrap>
                              {record.AdditionalDesignImages.map((img, idx) => (
                                <img key={idx} src={img.DesignPicture} alt={`تصویر اضافی ${idx + 1}`} style={{ maxWidth: 100, borderRadius: 8 }} />
                              ))}
                            </Space>
                          </>
                        )}
                      </div>
                    ),
                    rowExpandable: (record) => true
                  }}
                />
              </>
            )}

            <Divider orientation="center">خلاصه صورتحساب</Divider>

            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div style={{ background: 'rgba(162,56,84,0.05)', padding: '16px', borderRadius: '12px' }}>
                  <Row>
                    <Col span={12}>
                      <span>جمع کل محصولات:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>
                        {calculateProductTotal(selectedOrder).toLocaleString()} تومان
                      </span>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 8 }}>
                    <Col span={12}>
                      <span>هزینه ارسال:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      {(selectedOrder.ShippingCost || 0) > 0 ? (
                        <span>{(selectedOrder.ShippingCost || 0).toLocaleString()} تومان</span>
                      ) : (
                        <span style={{ color: 'green' }}>رایگان</span>
                      )}
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 8 }}>
                    <Col span={12}>
                      <span>مالیات بر ارزش افزوده (10%):</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>{calculateVAT(selectedOrder).toLocaleString()} تومان</span>
                    </Col>
                  </Row>
                  <Divider style={{ margin: '12px 0' }} />
                  <Row>
                    <Col span={12}>
                      <strong>جمع کل قابل پرداخت:</strong>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <strong style={{ color: '#a23854', fontSize: '18px' }}>
                        {calculateFinalTotal(selectedOrder).toLocaleString()} تومان
                      </strong>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </>
        )}
      </Modal>
    </Row>
  );
};

export default UserDashboard;